
















import { Component, Prop } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { SimproJobEntities } from '@/components/add business objects/models/simproJobs';
import { AddJobForm } from '@/components/add business objects/add-job/AddJobForm';
import AddJobFormEntityList from '@/components/add business objects/add-job/AddJobFormEntityList.vue';

@Component({
	components: {
		AddJobFormEntityList,
	},
	mixins: [validationMixin],
})
export default class AddJobFeedForm extends AddJobForm {
	@Prop()
	public feedTanks!: SimproJobEntities;

	@Prop({ default: false })
	public editing!: boolean;
}
